import { BlockSubstitutionsBonus, BoostAllPlayersBonus, BoostOnePlayerBonus, FourStrikersBonus, MirrorBonus, NerfAllPlayersBonus, NerfGoalkeeperBonus, NoneBonus, RemoveGoalBonus } from "@/models/bonus";

export const BONUSES = {
  none: NoneBonus,
  removeGoal: RemoveGoalBonus,
  blockTacticalSubs: BlockSubstitutionsBonus,
  boostAllPlayers: BoostAllPlayersBonus,
  fourStrikers: FourStrikersBonus,
  nerfAllPlayers: NerfAllPlayersBonus,
  nerfGoalkeeper: NerfGoalkeeperBonus,
  boostOnePlayer: BoostOnePlayerBonus,
  mirror: MirrorBonus,
};